var globalHelpers = require('../../globalHelpres');
module.exports = function(app) {
	'use strict'
	app.controller('tinymceBasicController',tinymceBasicController);
	tinymceBasicController.$inject=['countCharacters','editorExludeShortcode','parseOptions','refreshtokenService','getDataService','postDataService','alertService','serverError','offlineError','$rootScope','$element','$timeout','config','$compile',"reverseWpautop","jQuery","$window","$scope"];
	function tinymceBasicController(countCharacters,editorExludeShortcode,parseOptions,refreshtokenService,getDataService,postDataService,alertService,serverError,offlineError,$rootScope,$element,$timeout,config,$compile,reverseWpautop,jQuery, $window,$scope) {   
    $scope.config = config;
    $scope.windowWidth = window.innerWidth
    var editorHeight;
    var editorHeightFunction = function() {
        editorHeight = jQuery($element).find('.mce-edit-area').height();
        return editorHeight;
    }

    // Add function to handle modal iframe height
    function setModalEditorHeight() {
        if ($scope.$parent.editorModal && tinymce.activeEditor) {
            var viewportHeight = window.innerHeight;
            var modalHeaderHeight = 50;
            var padding = 140; // 60px for content paddong and 40px for modal padding and 40 to get some space
            if(window.innerWidth < 600) {
              var padding = 120; // 20px modal padding
            }
            var toolbarHeight = 36;
            var statusBarHeight = 36;
            var availableHeight = viewportHeight - modalHeaderHeight - padding - toolbarHeight - statusBarHeight;
            
            // Set height with !important only on the iframe
            var iframe = jQuery(tinymce.activeEditor.getContainer()).find('iframe');
            iframe.attr('style', 'height: ' + availableHeight + 'px !important; min-height: ' + availableHeight + 'px !important;max-height: ' + availableHeight + 'px !important;width: 100% !important;display: block !important;');
        }
    }

    function autoResizeHeight(ele) {
      ele.css('height','auto')
      ele.css('height',ele.scrollHeight + 'px')
    }
    $scope.charCount = 0;
    function updateCharacterCount() {
      if (tinymce.activeEditor) {
          var content = tinymce.activeEditor.getContent();
          $scope.charCount = countCharacters(content);
          // if (!$scope.$$phase) {
          //   $scope.$apply();
          // }
      }
    }
    if($scope.$parent.tag) {
      var insertTag = angular.element(document.getElementById('insertTag.html')).html();
    }
    var editorHtml = angular.element(document.getElementById('editor.html')).html();
    if($scope.$parent.video || $scope.$parent.quote || $scope.$parent.question) {
      var modal = angular.element(document.getElementById('modal.html')).html();
    }
    if($scope.$parent.news) {
      var insertPost = angular.element(document.getElementById('insertPost.html')).html();
    }
    if($scope.$parent.embed) {
      var insertEmbedCode = angular.element(document.getElementById('insertEmbedCode.html')).html();
    }
    $scope.selectedTypeVideo = {value:'default'};
    $scope.editor_preview_visual = true;
    if($scope.$parent.tag) {
      $scope.cancelInsertTagModal = function() {
        $scope.searchTag = null;
        jQuery($element).siblings('.editor-insert-tag').remove();
        $rootScope.modalShow = false;
      }
    }
    if($scope.$parent.news) {
      $scope.cancelInsertPostModal = function() {
        jQuery($element).siblings('.editor-insert-post').remove();
        $rootScope.modalShow = false;
      }
    }
    if($scope.$parent.embed) {
      $scope.cancelInsertEmbedCodeModal = function() {
        $scope.embedCode = '';
        jQuery($element).siblings('.editor-insert-embedcode').remove();
        $rootScope.modalShow = false;
      }
    }
    if($scope.$parent.video || $scope.$parent.quote || $scope.$parent.question) {
      $scope.cancelTinymceModal = function() {
        jQuery($element).siblings('.tinymce-modal').remove();
        $scope.videoModalShow = false;
        $scope.questionModalShow = true;
        $scope.quoteModalShow = true;
        $rootScope.modalShow = false;
      }
    }
    $scope.pasteText = function(event){
      event.preventDefault();
      var clp = (event.originalEvent || event).clipboardData;
      var text = clp.getData('text/plain')
      text = text.replace(/<p>/gmi, "");
      text = text.replace(/<p ([^>]*)>/gmi, "");
      text = text.replace(/<\/p>/g, "");
      document.execCommand('insertText', false, text);
    } 
    var minifyHtmlElement = function(content,ele) {
      var elements = content.getElementsByTagName(ele);
      for (var i = 0; i < elements.length; i++) {
        var htmlEl =elements[i].outerHTML;
        jQuery(elements[i]).replaceWith(htmlEl.replace(/^\s+|\r\n|\n|\r|(>)\s+(<)|\s+$/gm, '$1$2').replace(/<br \/>/g, '').replace(/<\/p>/g, '').replace(/<p>/g, ''));
      }
    }
    var stripEmptyElement = function(content,ele) {
      var elements = content.getElementsByTagName(ele);
      var isEmpty = function ( el ){
        return !jQuery.trim(el.html())
      }
      for (var i = 0; i < elements.length; i++) {
        
        if (isEmpty(jQuery(elements[i]))) {
          jQuery(elements[i]).remove();
        }
      }
    }
    var removeImage = function(parents) {
      for( var i=0; i < parents.length; i++ ) {
        if(parents[i].nodeName == 'IMG') {
          var image = parents[i];
          jQuery(image).remove();
        } else if(parents[i].nodeName =='A') {
          var parentAnchor = parents[i];
          jQuery(parentAnchor).remove();
        }else if(parents[i].nodeName == 'CAPTIONBLOCK') {
          var parentCaption = parents[i];
          jQuery(parentCaption).remove();
        }
      }
    }
    var  parseOptionsFunc = parseOptions;
    var contentSaveFunction = function() {
      if($scope.$parent.photo || $scope.$parent.aiEditor) {
        tinyMCE.activeEditor.dom.remove('edit-image');
      }
      if($scope.$parent.gallery || $scope.$parent.aiEditor) {
        tinyMCE.activeEditor.dom.remove('edit-gallery');
      }
      if($scope.$parent.embed || $scope.$parent.aiEditor) {
        tinyMCE.activeEditor.dom.remove('edit-embed');
      }
      minifyHtmlElement(tinymce.activeEditor.getBody(),"script")
      stripEmptyElement(tinymce.activeEditor.getBody(),"a")
      var postContent = tinymce.activeEditor.getContent();
      if($scope.$parent.photo || $scope.$parent.aiEditor) {
        postContent.replace(/\<captionblock([^\]].*?)>([^\]]*?)\<\/captionblock>/g, function(all, attr, con) {
          var parseOptions = parseOptionsFunc(attr);
          if(parseOptions.signature_url) {
            var signatureUrl = parseOptions.signature_url
          } else {
            var signatureUrl = ''
          }
          if(parseOptions.image_link) {
            var imageLink = 'image_link="'+parseOptions.image_link+'"'
          } else {
            var imageLink = ''
          }
          if(parseOptions.image_target_blank) { 
            var imageTargetBlank = 'image_target_blank="'+parseOptions.image_target_blank+'"'
          } else {
            var imageTargetBlank = ''
          }
          var imageLinkSummary = imageLink ? imageLink + (imageTargetBlank ? ' ' + imageTargetBlank : '') : '';
          postContent = postContent.replace( all,'[caption id="'+parseOptions.id+'" align="'+parseOptions.align+'" width="' +parseOptions.width +'" height="'+parseOptions.height+'" signature_url="'+ signatureUrl +'" '+imageLinkSummary+']'+con+'[/caption]\n\n');
        });
      }
      if($scope.$parent.gallery || $scope.$parent.aiEditor) {
        postContent.replace(/\<galleryblock([^\]].*?)>(.*?)\<\/galleryblock>/g, function(all, attr, con) {
          postContent = postContent.replace( all, con+'\n\n');
        });
      }
      if($scope.$parent.embed || $scope.$parent.aiEditor) {
        postContent.replace(/\<embedblock([^\]].*?)>(.*?)\<\/embedblock>/g, function(all, attr, con) {
          var parseOptions = parseOptionsFunc(attr);
          var type = parseOptions.type || parseOptions.src;
          postContent = postContent.replace( all,'[embed type="'+type+'"]'+con+'[/embed]\n\n');
        });
      }
      postContent = reverseWpautop(postContent);
      if($scope.$parent.aiEditor) {
        // Find the editor instance by looking for the iframe with ui-tinymce prefix
        var editors = tinymce.editors;
        var targetEditor = null;
        
        // Find the editor that's in our scope
        for (var i = 0; i < editors.length; i++) {
            var editorElement = editors[i].getElement();
            if (editorElement && editorElement.closest('#tinymce-basic-1')) { // order 1 is suggestion editor
                targetEditor = editors[i];
                break;
            }
        }

        // editorText is actually aiSuggestion from parent scope
        if (targetEditor) {
            $scope.$parent.editorText.content = targetEditor.getContent();
        } else {
          $scope.$parent.editorText.content = tinymce.activeEditor.getContent();
        }
        
        // Force digest cycle if needed
        if (!$scope.$$phase && !$scope.$root.$$phase) {
          $scope.$apply();
        }
      } else {
        $scope.$parent.editorText.content = postContent;
      }
    }
    var optionsToolbar = '';
    if($scope.$parent.options.length>0) {
      for(var i = 0;i<$scope.$parent.options.length;i++) {
        optionsToolbar = optionsToolbar + ' '+ $scope.$parent.options[i] +' |'
      }
    }
    var toolbar = 'formath2 formath3 | bold italic  | bullist numlist | hr | link unlink |'+ optionsToolbar +' pagebreak | undo redo | fullscreen '
    if($scope.$parent.aiEditor) {
      toolbar = 'bold italic | link unlink | undo redo'
    }
    var validChildren = ''
    if($scope.$parent.embed || $scope.$parent.aiEditor) {
      validChildren = validChildren + ',embedblock[blockquote,script,iframe,div]'
    }
    var extendedValidElements = '';
    if($scope.$parent.photo || $scope.$parent.aiEditor) {
      extendedValidElements = extendedValidElements + ',captionblock[id|align|width|height|signature_url]'
    }
    if($scope.$parent.gallery || $scope.$parent.aiEditor) {
      extendedValidElements = extendedValidElements + ',galleryblock[ids|title|safe|span|id]'
    }
    if($scope.$parent.embed || $scope.$parent.aiEditor) {
      extendedValidElements = extendedValidElements + ',embedblock[*]'
    }
    var customElements = '';
    if($scope.$parent.photo || $scope.$parent.aiEditor) {
      customElements = customElements + 'captionblock'
    }
    if($scope.$parent.gallery || $scope.$parent.aiEditor) {
      customElements = customElements + ',galleryblock'
    }
    if($scope.$parent.embed || $scope.$parent.aiEditor) {
      customElements = customElements + ',embedblock'
    }
    var link = ($scope.$parent.customLink)?'customLink':'link'
    $scope.tinymceOptions = {
      selector: "textarea",
      id: 'tinymce-basic-'+$scope.$parent.order,
      format:'raw',
      menubar:false,
      verify_html : true,
      plugins: [
          'lists '+link+' image anchor',
          'fullscreen',
          'autoresize hr pagebreak paste'
      ],
      skin: false,
      // Prevent HTML entity conversion to preserve &quot; in title attributes
      entity_encoding: 'raw',
      encoding: 'html',
      // Disable automatic entity conversion
      convert_urls: false,
      urlconverter_callback: function(url,node,on_save, name) {
        var url = url;
        if(!url.includes('http') && node.nodeName == 'A' && name=='href' && !url.includes('#blogpost_')) {
          url= 'http://' + url
        }
        return url 
      },
      // // theme : 'modern',
      toolbar: toolbar,
      valid_elements : "@[id|class|style|title|dir<ltr?rtl|lang|xml::lang|onclick|ondblclick|"
      + "onmousedown|onmouseup|onmouseover|onmousemove|onmouseout|onkeypress|"
      + "onkeydown|onkeyup],a[rel|rev|charset|hreflang|tabindex|accesskey|type|"
      + "name|href|target|title|class|onfocus|onblur|style],strong/b,em/i,strike,u,"
      + "#p,-ol[type|compact],-ul[type|compact],-li,br,img[longdesc|usemap|"
      + "src|border|alt=|title|hspace|vspace|width|height|align],-sub,-sup,"
      + "-blockquote[*],-table[border=0|cellspacing|cellpadding|width|frame|rules|"
      + "height|align|summary|bgcolor|background|bordercolor],-tr[rowspan|width|"
      + "height|align|valign|bgcolor|background|bordercolor],tbody,thead,tfoot,"
      + "#td[colspan|rowspan|width|height|align|valign|bgcolor|background|bordercolor"
      + "|scope],#th[colspan|rowspan|width|height|align|valign|scope],caption,#div,"
      + "span[*],-code,-pre,address,-h1,-h2,-h3,-h4,-h5,-h6,hr[size|noshade],-font[face"
      + "|size|color],dd,dl,dt,cite,abbr,acronym,del[datetime|cite],ins[datetime|cite],"
      + "object[classid|width|height|codebase|*],param[name|value|_value],embed[type|width"
      + "|height|src|*],script[src|type|language|async|defer|charset],map[name],area[shape|coords|href|alt|target],bdo,"
      + "button,col[align|char|charoff|span|valign|width],colgroup[align|char|charoff|span|"
      + "valign|width],dfn,fieldset,form[action|accept|accept-charset|enctype|method],"
      + "input[accept|alt|checked|disabled|maxlength|name|readonly|size|src|type|value],"
      + "kbd,label[for],legend,noscript,optgroup[label|disabled],option[disabled|label|selected|value],"
      + "q[cite],samp,select[disabled|multiple|name|size],small,"
      + "textarea[cols|rows|disabled|name|readonly],tt,var,big,time,iframe[*],-section[*]",
      extended_valid_elements : "+svg[*],+g[*],+path[*],+video[*],+source[*]" + extendedValidElements,
      custom_elements: customElements,
      valid_children: "+p[strong|a|b|img|i|br|em|script|iframe|blockquote|time],+a[div]"+ validChildren, // "+" add valid children
      content_css: [
          'tinymce/custom-tinymce.css?v=13'
      ],
      body_class: 'custom_class',
      default_link_target: "_blank",
      rel_list: [
        {title: 'DoFollow', value: ''},
        {title: 'NoFollow', value: 'nofollow'},
        {title: 'Sponsored', value: 'sponsored'}
      ],
      target_list:[
        { title: 'Current window', value: '' },
        { title: 'New window', value: '_blank' }
      ],
      forced_root_block : false,
      force_p_newlines : true,
      remove_linebreaks : false,
      relative_urls : false,
      remove_script_host : false,
      indent: false,
      // paste_text_sticky_default: true,
      // force_br_newlines : true,
      remove_trailing_nbsp : false,
      style_formats: [
        {title: 'Heading 2', format: 'h2'},
        {title: 'Heading 3', format: 'h3'},
        {title: 'Heading 4', format: 'h4'},
        {title: 'Heading 5', format: 'h5'},
        {title: 'Heading 6', format: 'h6'},
      ],
      paste_preprocess: function(plugin, args) {
        // Decode HTML entities while preserving HTML structure
        function decodeHtml(html) {
          var txt = document.createElement("textarea");
          txt.innerHTML = html;
          return txt.value;
        }

        var decodedContent = decodeHtml(args.content);

        // Check if content contains embedblock, galleryblock or captionblock
        if (/<(embed|gallery|caption)block/i.test(decodedContent)) {
          // Set the decoded HTML content back to args.content so it gets pasted as HTML
          args.content = decodedContent;
          return;
        }

        // Only block actual script/iframe tags or javascript: URLs
        var dangerousPattern = /(<script|<iframe|&lt;script|&lt;iframe|script<\/span>|iframe<\/span>|javascript:)/i;
        if (dangerousPattern.test(args.content)) {
          // Block the paste and notify the user
          args.content = ''; // Clear the content
          $scope.$apply(function() {
            alertService('danger', 'Oops!', 'Pasting of <script> or <iframe> tags is not allowed! Use embed code button.');
          });
          return;
        }

        // For other content, apply the whitelist
        var whitelist = 'p,strong,i,em,br,a';
        var content = args.content;
        if(args.content.match(/<br>|<br \/>/g)) {
          content = wpautop(args.content.replace(/<br>|<br \/>/g, "\n"));
        }
        var stripped = jQuery('<div>' + content + '</div>');
        var els = stripped.find('*').not(whitelist);
        for (var i = els.length - 1; i >= 0; i--) {
          var e = els[i];
          jQuery(e).replaceWith(e.innerHTML);
        }
        // Strip all class and id attributes
        stripped.find('*').removeAttr('id').removeAttr('class');
        // Return the clean HTML
        args.content = stripped.html();
      },
      paste_postprocess : function(pl, o) {
          // remove extra line breaks
          o.node.innerHTML = o.node.innerHTML.replace(/&nbsp;/ig, " ");
      },
      init_instance_callback: function (editor) {
        editor.on('SetContent', function (e) {
          editor.setDirty(true);
          editor.fire('change')
        }); 
        
        // Custom serializer to preserve HTML entities in title attributes
        editor.serializer.addAttributeFilter('title', function(nodes, name) {
          var i = nodes.length, node;
          while (i--) {
            node = nodes[i];
            if (node.attr('title')) {
              // Preserve HTML entities in title attributes
              var title = node.attr('title');
              // Ensure quotes are properly encoded as &quot;
              title = title.replace(/"/g, '&quot;');
              node.attr('title', title);
            }
          }
        });

        $scope.$watch(function(){
          return $scope.$parent.update
        }, function(newValue, oldValue){
          if (newValue) {
            editor.setContent($scope.$parent.tinymceModel);
          }
        },true);  
        editor.serializer.addNodeFilter('script,style', function(nodes, name) {
          var i = nodes.length, node, value, type;

          function trim(value) {
              /*jshint maxlen:255 */
              /*eslint max-len:0 */
              return value.replace(/(<!--\[CDATA\[|\]\]-->)/g, '\n')
                      .replace(/^[\r\n]*|[\r\n]*$/g, '')
                      .replace(/^\s*((<!--)?(\s*\/\/)?\s*<!\[CDATA\[|(<!--\s*)?\/\*\s*<!\[CDATA\[\s*\*\/|(\/\/)?\s*<!--|\/\*\s*<!--\s*\*\/)\s*[\r\n]*/gi, '')
                      .replace(/\s*(\/\*\s*\]\]>\s*\*\/(-->)?|\s*\/\/\s*\]\]>(-->)?|\/\/\s*(-->)?|\]\]>|\/\*\s*-->\s*\*\/|\s*-->\s*)\s*$/g, '');
          }
          while (i--) {
              node = nodes[i];
              value = node.firstChild ? node.firstChild.value : '';

              if (value.length > 0) {
                  node.firstChild.value = trim(value);
              }
          }
        });
      },
      setup: function(editor) {
        editor.on('PreInit', function() {
          tinyMCE.activeEditor.schema.getNonEmptyElements().svg = {}
        });
        if($scope.$parent.photo || $scope.$parent.gallery || $scope.$parent.embed || $scope.$parent.aiEditor || $scope.$parent.aiEditor) {
          var setCursorAfterCaptionFunction = function(e) {
            var dom = tinymce.activeEditor.dom; 
            var parents = dom.getParents( tinymce.activeEditor.selection.getNode() );
            function setCursorToNewParagraph(){
              var newParagraph = dom.select( 'p#' + uniqueID )[0];
              tinymce.activeEditor.selection.setCursorLocation( newParagraph );
            }
            for( var i=0; i < parents.length; i++ ) {
              var currentNode = parents[i];
              // Insert empty paragraph at the end of the parent of the closest custom tag
              if( currentNode.nodeName == 'CAPTIONBLOCK' || currentNode.nodeName == 'GALLERYBLOCK' || currentNode.nodeName == 'EMBEDBLOCK') {
                  // dom.insertAfter doesn't work reliably
                  if(jQuery(currentNode).parent('p').get(0)) {
                    currentNode = jQuery(currentNode).parent('p')
                  }
                  if(e) {
                    var event = window.event ? window.event : e;
                    if(event.keyCode != 37 && event.keyCode != 38 && event.keyCode != 39 && event.keyCode != 40) {
                      var uniqueID = dom.uniqueId();
                      if(!e.shiftKey) {
                        jQuery( '<p id="' + uniqueID + '"><br /></p>' ).insertAfter( currentNode );
                        setCursorToNewParagraph() 
                      } else if (event.keyCode == 13 && e.shiftKey) {
                        jQuery( '<p id="' + uniqueID + '"><br /></p>' ).insertBefore( currentNode );
                        setCursorToNewParagraph()
                      }
                      e.preventDefault();
                      // Move to the new node
                    }
                  } else {
                    var uniqueID = dom.uniqueId();
                    jQuery( '<p id="' + uniqueID + '"><br /></p>' ).insertAfter( currentNode );
                    
                    // Move to the new node
                    setCursorToNewParagraph()
                  }
                  // Don't create an extra paragraph
                  editor.setDirty(true);
                  editor.fire('change')
                  break;
              }
            }
          }
        }
        if($scope.$parent.photo) {
          var editImageArray = {};
          var image_id;
          var insertOrUpdateImage = function(imgArray,update) {
            var insertImage={};
            // var insertImages = '';
            for(var i=0; i<imgArray.length;i++) {
              insertImage[i] = '<img src="'+ imgArray[i].thumbs["830x0"] +'" alt = "'+imgArray[i].title+'" class="wp-image-'+imgArray[i]._id+'"/>';
              if(imgArray[i].link_to) {
                insertImage[i] = '<a href="'+imgArray[i].link_to+'"><img src="'+ imgArray[i].thumbs["830x0"] +'" alt = "'+imgArray[i].title+'" class="wp-image-'+imgArray[i]._id+'"/></a>'; 
                if(imgArray[i].target_blank) {
                 insertImage[i] = '<a href="'+imgArray[i].link_to+'" target="_blank"><img src="'+ imgArray[i].thumbs["830x0"] +'" alt = "'+imgArray[i].title+'" class="wp-image-'+imgArray[i]._id+'"/></a>'; 
                }
              }
              if(imgArray[i].signature) {
                if(imgArray[i]._id in editImageArray) {
                  editImageArray[imgArray[i]._id].signature_image = imgArray[i].signature;
                }
                if(imgArray[i].meta && imgArray[i].meta.signature_url) {
                  var signatureUrl = imgArray[i].meta.signature_url
                } else {
                  var signatureUrl = ''
                }
                insertImage[i] = '<captionblock id="attachment_'+imgArray[i]._id+'" align="'+imgArray[i].align+'" width="'+imgArray[i].meta.width+'" height="'+imgArray[i].meta.height+'" signature_url="'+signatureUrl+'"><img src="'+ imgArray[i].thumbs["830x0"] +'" alt = "'+imgArray[i].title+'" class="wp-image-'+imgArray[i]._id+'"/>'+imgArray[i].signature+'</captionblock>';
                if (imgArray[i].link_to) {
                  insertImage[i] = '<captionblock id="attachment_'+imgArray[i]._id+'" align="'+imgArray[i].align+'" width="'+imgArray[i].meta.width+'" height="'+imgArray[i].meta.height+'" signature_url="'+signatureUrl +'"><a href="'+imgArray[i].link_to+'"><img src="'+ imgArray[i].thumbs["830x0"] +'" alt = "'+imgArray[i].title+'" class="wp-image-'+imgArray[i]._id+'"/>'+imgArray[i].signature+'</a></captionblock>';
                  if(imgArray[i].target_blank) {
                    insertImage[i] = '<captionblock id="attachment_'+imgArray[i]._id+'" align="'+imgArray[i].align+'" width="'+imgArray[i].meta.width+'" height="'+imgArray[i].meta.height+'" signature_url="'+signatureUrl+'"><a href="'+imgArray[i].link_to+'" target="_blank"><img src="'+ imgArray[i].thumbs["830x0"] +'" alt = "'+imgArray[i].title+'" class="wp-image-'+imgArray[i]._id+'"/>'+imgArray[i].signature+'</a></captionblock>';
                  }
                };
              } else {
                insertImage[i] = '<p>'+insertImage[i]+'</p>';
                if(imgArray[i]._id in editImageArray) {
                  editImageArray[imgArray[i]._id].signature_image = null;
                }
              }
              if(!update) {
                setCursorAfterCaptionFunction();
              }
              tinymce.activeEditor.execCommand('mceInsertContent', false, insertImage[i]);
            //  insertImages = insertImages.concat(insertImage[i]);
            }
          }
          var insertOrUpdateImage = function(imgArray,update) {
            var insertImage={};
            // var insertImages = '';
            for(var i=0; i<imgArray.length;i++) {
              insertImage[i] = '<img src="'+ imgArray[i].thumbs["830x0"] +'" alt = "'+imgArray[i].title+'" class="wp-image-'+imgArray[i]._id+'"/>';
              if(imgArray[i].link_to) {
                insertImage[i] = '<a href="'+imgArray[i].link_to+'"><img src="'+ imgArray[i].thumbs["830x0"] +'" alt = "'+imgArray[i].title+'" class="wp-image-'+imgArray[i]._id+'"/></a>'; 
                if(imgArray[i].target_blank) {
                 insertImage[i] = '<a href="'+imgArray[i].link_to+'" target="_blank"><img src="'+ imgArray[i].thumbs["830x0"] +'" alt = "'+imgArray[i].title+'" class="wp-image-'+imgArray[i]._id+'"/></a>'; 
                }
              }
              if(imgArray[i].signature) {
                if(imgArray[i]._id in editImageArray) {
                  editImageArray[imgArray[i]._id].signature_image = imgArray[i].signature;
                }
                if(imgArray[i].meta && imgArray[i].meta.signature_url) {
                  var signatureUrl = imgArray[i].meta.signature_url
                } else {
                  var signatureUrl = ''
                }
                insertImage[i] = '<captionblock id="attachment_'+imgArray[i]._id+'" align="'+imgArray[i].align+'" width="'+imgArray[i].meta.width+'" height="'+imgArray[i].meta.height+'" signature_url="'+signatureUrl+'"><img src="'+ imgArray[i].thumbs["830x0"] +'" alt = "'+imgArray[i].title+'" class="wp-image-'+imgArray[i]._id+'"/>'+imgArray[i].signature+'</captionblock>';
                if (imgArray[i].link_to) {
                  insertImage[i] = '<captionblock id="attachment_'+imgArray[i]._id+'" align="'+imgArray[i].align+'" width="'+imgArray[i].meta.width+'" height="'+imgArray[i].meta.height+'" signature_url="'+signatureUrl +'"><a href="'+imgArray[i].link_to+'"><img src="'+ imgArray[i].thumbs["830x0"] +'" alt = "'+imgArray[i].title+'" class="wp-image-'+imgArray[i]._id+'"/>'+imgArray[i].signature+'</a></captionblock>';
                  if(imgArray[i].target_blank) {
                    insertImage[i] = '<captionblock id="attachment_'+imgArray[i]._id+'" align="'+imgArray[i].align+'" width="'+imgArray[i].meta.width+'" height="'+imgArray[i].meta.height+'" signature_url="'+signatureUrl+'"><a href="'+imgArray[i].link_to+'" target="_blank"><img src="'+ imgArray[i].thumbs["830x0"] +'" alt = "'+imgArray[i].title+'" class="wp-image-'+imgArray[i]._id+'"/>'+imgArray[i].signature+'</a></captionblock>';
                  }
                };
              } else {
                insertImage[i] = '<p>'+insertImage[i]+'</p>';
                if(imgArray[i]._id in editImageArray) {
                  editImageArray[imgArray[i]._id].signature_image = null;
                }
              }
              if(!update) {
                setCursorAfterCaptionFunction();
              }
              tinymce.activeEditor.execCommand('mceInsertContent', false, insertImage[i]);
            //  insertImages = insertImages.concat(insertImage[i]);
            }
          }
          var addMediaListener = $scope.$on("add-media-to-editor",function(event, data) {
            tinyMCE.activeEditor.dom.remove('edit-image');
            for(var i=0;i<data.insertMediaArray.length;i++) {
    
              if(data.insertMediaArray[i].align === 'undefined' || !data.insertMediaArray[i].align) data.insertMediaArray[i].align = 'alignnone' 
              editImageArray[data.insertMediaArray[i]._id] = {
                id : data.insertMediaArray[i]._id,
                align : data.insertMediaArray[i].align,
                href : data.insertMediaArray[i].href,
                target_blank : data.insertMediaArray[i].target_blank,
                signature_image : data.insertMediaArray[i].signature || null
              }
            }
            insertOrUpdateImage(data.insertMediaArray);
            setTimeout(function() {
              tinymce.activeEditor.execCommand('mceAutoResize');
            },100)
          });
          $scope.$on('$destroy', addMediaListener);
          var updateMediaListener = $scope.$on("update-image-editor",function(event, data) {
            var nodeImage = tinyMCE.activeEditor.dom.get('selected-image');
            var parents = tinyMCE.activeEditor.dom.getParents(nodeImage);
            tinyMCE.activeEditor.dom.remove('edit-image');
            setCursorAfterCaptionFunction();
            removeImage(parents)
            if(data.updateImageObject.align === 'undefined' || !data.updateImageObject.align) data.updateImageObject.align = 'alignnone';
            var insertMediaArray = [data.updateImageObject];
            insertOrUpdateImage(insertMediaArray,true);
            var editorContentBody = tinymce.activeEditor.getBody();
            stripEmptyElement(editorContentBody,"p");
            tinyMCE.activeEditor.dom.remove(nodeImage);   
          });
          $scope.$on('$destroy', updateMediaListener);
          var deleteMedia = $scope.$on("delete-media",function(event, data) {
            var nodeImage = tinyMCE.activeEditor.dom.get('selected-image');
            var parents = tinyMCE.activeEditor.dom.getParents(nodeImage);
            tinyMCE.activeEditor.dom.remove('edit-image');
            tinyMCE.activeEditor.dom.remove('selected-image')
            removeImage(parents)
            editor.setDirty(true);
            editor.fire('change')   
          });
          $scope.$on('$destroy', deleteMedia);
        }
        if($scope.$parent.gallery) {
          var addSlideshowListener = $scope.$on("insert-gallery",function(event, data) {
            if(data.update) {
              tinymce.activeEditor.selection.setCursorLocation( tinymce.activeEditor.dom.select( '#selected-gallery')[0] )
              tinyMCE.activeEditor.dom.remove('edit-gallery');
              setCursorAfterCaptionFunction();
              tinyMCE.activeEditor.dom.remove('selected-gallery');
            }
            var attachments_ids = data.attachments_ids.join();
            var title;
            if(data.gallery_title) {
              title = data.gallery_title
            } else {
              title=''
            }
            var insertslideShowShortcode = '<galleryblock ids="' + attachments_ids +'" safe="' + !data.slideShowUnsafe+ '" title="' + title + '">[gallery ids="' + attachments_ids +'" safe="' + !data.slideShowUnsafe+ '" title="' + title + '"]</galleryblock>';
            setCursorAfterCaptionFunction();
            tinymce.activeEditor.execCommand('mceInsertContent', false, insertslideShowShortcode);
          });
          $scope.$on('$destroy', addSlideshowListener);
        }
        if($scope.$parent.telegraftv) {
          var addTelegrafTvListener = $scope.$on("insert-telegraftv",function(event, data) {
            var postContent = $scope.$parent.editorText.content;
            var validation = true;
            postContent.replace(/\[video(.*?)?\](?:([\s\S]*?)(\[\/video\]))?/g, function(all, attr, con) {
                  var parseOptions = parseOptionsFunc(attr);
                  if(parseOptions.id == data.videoId) {
                    validation = false;
                    alertService('danger','Opps! ', 'This video alredy exist!!!');
                    return
                  }
            });
            if(validation) {
              var title=(data.showVideoTitle)? data.title: '';
              var align = (data.showVideoTitle)? data.align: '';
              var inserVtelegrafVideoShortcode = '[video id="'+data.videoId + '" title="' + title + '" align="' + align + '"]';
              setCursorAfterCaptionFunction();
              tinymce.activeEditor.execCommand('mceInsertContent', false, '<p>'+inserVtelegrafVideoShortcode+'</p>');
              $timeout(function(){
                $scope.$parent.cancelVideoModal()
              },0)
            }
          });
          $scope.$on('$destroy', addTelegrafTvListener);
        }
        if($scope.$parent.poll) {
          var addPollListener = $scope.$on("insert-poll-to-editor",function(event, data) {
            var postContent = $scope.$parent.editorText.content;
            var validation = true;
            postContent.replace(/\[poll(.*?)?\](?:([\s\S]*?)(\[\/poll\]))?/g, function(all, attr, con) {
                  var parseOptions = parseOptionsFunc(attr);
                  if(parseOptions.id == data._id) {
                    validation = false;
                    alertService('danger','Opps! ', 'This poll alredy exist!!!');
                    return
                  }
            });
            if(validation) {
              if(data.hasOwnProperty('result')) {
                var insertPollShortcode = '[poll id="'+data._id + '" result="'+ data.result +'"]'+data._id+'[/poll]';
              } else {
                var insertPollShortcode = '[poll id="'+data._id + '"]'+data._id+'[/poll]';
              }
              setCursorAfterCaptionFunction();
              tinymce.activeEditor.execCommand('mceInsertContent', false, '<p>'+insertPollShortcode+'</p>');
            }
          });
          $scope.$on('$destroy', addPollListener);
        }
        if($scope.$parent.rating) {
          var addRatingListener = $scope.$on("insert-rating-to-editor",function(event, data) {
            var postContent = $scope.$parent.editorText.content;
            var validation = true;
            postContent.replace(/\[rating(.*?)?\](?:([\s\S]*?)(\[\/rating\]))?/g, function(all, attr, con) {
              var parseOptions = parseOptionsFunc(attr);
              if(parseOptions.id == data._id) {
                validation = false;
                alertService('danger','Opps! ', 'This rating alredy exist!!!');
                return
              }
            });
            if(validation) {  
              if(data.hasOwnProperty('result')) {
                var insertRatingShortcode = '[rating id="'+data._id + '" result="'+ data.result +'"]'+data._id+'[/rating]';
              } else {
                var insertRatingShortcode = '[rating id="'+data._id + '"]'+data._id+'[/rating]';
              }
              setCursorAfterCaptionFunction();  
              tinymce.activeEditor.execCommand('mceInsertContent', false, '<p>'+insertRatingShortcode+'</p>');
            }
          });
          $scope.$on('$destroy', addRatingListener);
        }
        if($scope.$parent.blog) {
          var addBlogListener = $scope.$on("insert-blog-to-editor",function(event, data) {
            var postContent = $scope.$parent.editorText.content;
            var validation = true;
            postContent.replace(/\[liveblog(.*?)?\](?:([\s\S]*?)(\[\/liveblog\]))?/g, function(all, attr, con) {
                  var parseOptions = parseOptionsFunc(attr);
                  if(parseOptions.id == data._id) {
                    validation = false;
                    alertService('danger','Opps! ', 'This live blog alredy exist!!!');
                    return
                  }
            });
            if(validation) {
              var insertBlogShortcode = '[liveblog id="'+data._id + '"]'+data._id+'[/liveblog]';
              setCursorAfterCaptionFunction();
              tinymce.activeEditor.execCommand('mceInsertContent', false, '<p>'+insertBlogShortcode+'</p>');
            }
          });
          $scope.$on('$destroy', addBlogListener);
        }
        editor.on("init", function() {
          setModalEditorHeight()
          if($scope.$parent.editorCharCount) {
            // Add character counter element after the editor
            var counterHtml = '<div class="editor-character-count">Characters: <span ng-class="{\'danger-color\': charCount < 800}">{{charCount}}</span></div>';
            jQuery($element).find('.mce-edit-area').after($compile(counterHtml)($scope));
            // Initial count
            updateCharacterCount();
          }
          var statusbar_editor = jQuery($element).find(".mce-statusbar");
          if($scope.$parent.textModePermision || $scope.$parent.photo) {
            var change_preview_wrap = jQuery($element).siblings(".change-preview-wrapper");
          }
          if($scope.$parent.photo) {
            var add_madia_editor = jQuery($element).siblings(".change-preview-wrapper").find(".add-media-editor");
          }
          var toolbar_editor = jQuery($element).find(".mce-toolbar-grp");
          var editarea_editor = jQuery($element).find(".mce-edit-area");
          jQuery(editarea_editor).after($compile(editorHtml)($scope));
          var editor_plain_text = jQuery($element).find(".editor-plain-text");
          jQuery(editor_plain_text).on('input', function () {
            autoResizeHeight(this)
          }); 
          $scope.onScrollAction = function(){
              var width = jQuery('.single-post--left-col').width() -2;
              var offset = jQuery($element).offset();
              var topPos = offset.top;
              var leftPos = offset.left;
              editorHeightFunction();
              //the current height
              var y = window.scrollY || window.pageYOffset;
              //If the current Y is bigger than the element. (you scrolled beyond the element)
              if($scope.$parent.textModePermision || $scope.$parent.photo) {
                var change_preview_wrapHeight = jQuery(change_preview_wrap).outerHeight()
              } else {
                var change_preview_wrapHeight = 0
              }
              if(y >= topPos - change_preview_wrapHeight && y< topPos + editorHeight - 150){
                jQuery(editarea_editor).css('padding-top',jQuery(toolbar_editor).outerHeight()+change_preview_wrapHeight);
                jQuery(toolbar_editor).css({'position':'fixed','top':change_preview_wrapHeight,'left':leftPos, 'z-index':9999,'width':width,'border':'1px solid rgba(0,0,0,0.2)'});
                if($scope.$parent.textModePermision || $scope.$parent.photo) {
                  jQuery(change_preview_wrap).css({'position':'fixed','top':0,'left':leftPos, 'z-index':9999,'width':width +2,'border-bottom':'none'});
                }
                if(!$scope.editor_preview_visual && $scope.$parent.textModePermision) {
                  jQuery(change_preview_wrap).css({'border-bottom':'1px solid rgba(0,0,0,0.2)'});
                }
                  //do something
              } else {
                jQuery(editarea_editor).css('padding-top',0);
                jQuery(toolbar_editor).css({'position':'static','top':'auto','left':'auto', 'z-index':9999,'width':'auto','border':'none'});
                if($scope.$parent.textModePermision || $scope.$parent.photo) {
                  jQuery(change_preview_wrap).css({'position':'static','width':'100%','border-bottom':'none'});
                }
                if(!$scope.editor_preview_visual && $scope.$parent.textModePermision) {
                  jQuery(change_preview_wrap).css({'border-bottom': 'none'});
                }
              }
          };
          $scope.onResizeAction = function() {
            if($scope.windowWidth == window.innerWidth) return
            $scope.windowWidth = window.innerWidth
            tinyMCE.activeEditor.dom.remove('edit-gallery');
            tinyMCE.activeEditor.dom.remove('edit-image');
            tinyMCE.activeEditor.dom.remove('edit-embed');
            $scope.onScrollAction()
            setModalEditorHeight()
          }
          angular.element($window).on('scroll', $scope.onScrollAction);
          angular.element($window).on('resize', $scope.onResizeAction);
          $scope.$on("change-editor",function(event, data) {
            if(data.editor_preview == 'visual') {
                $scope.editor_preview_visual = true;
                jQuery(add_madia_editor).removeClass('hidden');
                jQuery(toolbar_editor).removeClass('hidden');
                jQuery(editarea_editor).removeClass('hidden');
                jQuery(statusbar_editor).removeClass('hidden');
                jQuery(editor_plain_text).addClass('hidden');
                if($scope.$parent.editorCharCount) {
                  jQuery($element).find('.editor-character-count').removeClass('hidden');
                }
                var editorContent = $scope.$parent.editorText.content;
                if($scope.$parent.photo) {
                  editorContent.replace(/\[caption([^\]].*?)\]([^\]]*?)\[\/caption\]/g, function(all, attr, con) {
                    var parseOptions = parseOptionsFunc(attr);
                    if(parseOptions.signature_url) {
                      var signatureUrl = parseOptions.signature_url
                    } else {
                    var signatureUrl = ''
                    }
                    if(parseOptions.image_link) {
                      var imageLink = 'image_link="'+parseOptions.image_link+'"'
                    } else {
                      var imageLink = ''
                    }
                    if(parseOptions.image_target_blank) {
                      var imageTargetBlank = 'image_target_blank="'+parseOptions.image_target_blank+'"'
                    } else {
                      var imageTargetBlank = ''
                    }
                    var imageLinkSummary = imageLink ? imageLink + (imageTargetBlank ? ' ' + imageTargetBlank : '') : '';
                    editorContent = editorContent.replace( all,'<captionblock id="'+parseOptions.id+'" align="'+parseOptions.align+'" width="' +parseOptions.width +'" height="'+parseOptions.height+'" signature_url="'+ signatureUrl +'" '+imageLinkSummary+'>'+con+'</captionblock>');
                  });
                }
                if($scope.$parent.gallery) {
                  editorContent.replace(/\[gallery([^\]].*?)\]/g, function(all, attr) {
                    var parseOptions = parseOptionsFunc(attr);
                    var title;
                    if(parseOptions.title) {
                      title =parseOptions.title
                    } else {
                      title=''
                    }
                    editorContent = editorContent.replace( all,'<galleryblock ids="'+parseOptions.ids+'" safe="'+parseOptions.safe+'" title="' + title +'">[gallery ids="'+parseOptions.ids+'" safe="'+parseOptions.safe+'" title="' + title +'"]</galleryblock>');
                  });
                }
                if($scope.$parent.embed) {
                  editorContent.replace(/\[embed\s+([^\]]*?)\]([\s\S]*?)\[\/embed\]/g, function(all, attr, con) {
                    var parseOptions = parseOptionsFunc(attr);
                    var type = parseOptions.type || parseOptions.src;
                    editorContent = editorContent.replace( all,'<embedblock type="'+type+'">'+con+'</embedblock>');
                  });
                }
                editorContent = wpautop(editorContent)
                tinyMCE.activeEditor.setContent(editorContent);
                contentSaveFunction();
            } else {
                $scope.editor_preview_visual = false;
                stripEmptyElement(tinymce.activeEditor.getBody(),"p");
                contentSaveFunction();
                jQuery(editor_plain_text).removeClass('hidden');
                autoResizeHeight(editor_plain_text);
                jQuery(editarea_editor).addClass('hidden');
                jQuery(statusbar_editor).addClass('hidden');
                jQuery(toolbar_editor).addClass('hidden');
                jQuery(add_madia_editor).addClass('hidden');
                if($scope.$parent.editorCharCount) {
                  jQuery($element).find('.editor-character-count').addClass('hidden');
                }
            }
          });
        });
        editor.on('keydown', function( event ) {
          if($scope.$parent.photo || $scope.$parent.aiEditor) {
            tinyMCE.activeEditor.dom.remove('edit-image');
          }
          if($scope.$parent.gallery || $scope.$parent.aiEditor) {
            tinyMCE.activeEditor.dom.remove('edit-gallery');
          }
          if($scope.$parent.embed || $scope.$parent.aiEditor) {
            tinyMCE.activeEditor.dom.remove('edit-embed');
          }
          if($scope.$parent.photo || $scope.$parent.gallery || $scope.$parent.embed || $scope.$parent.aiEditor) {
            if (event.keyCode === 8) {
              // Get the currently selected node within the editor
              var selectedNode = editor.selection.getNode();
      
              // Check if the selected node is a paragraph
              if (selectedNode && selectedNode.nodeName === 'P') {
                  // Check if the cursor is positioned at the beginning of the paragraph
                  var selection = editor.selection.getRng();
                  if (selection.startOffset === 0 && selection.endOffset === 0) {
                      // Get the previous sibling of the paragraph
                      var prevSibling = selectedNode.previousSibling;
      
                      // Check if the previous sibling is an embedblock
                      if (prevSibling && (prevSibling.nodeName === 'CAPTIONBLOCK' || prevSibling.nodeName === 'EMBEDBLOCK' || prevSibling.nodeName === 'GALLERYBLOCK')) {
                          // Prevent the default behavior of the backspace key
  
                          event.preventDefault();
                          if(!selectedNode.textContent.trim()) {
                            editor.dom.remove(selectedNode);
                          }
                          var range = editor.dom.createRng();
                          range.selectNodeContents(prevSibling);
                          range.collapse(false); // Move to the end
                          editor.selection.setRng(range);
                          return
                      }
                  }
              }
            }
            setCursorAfterCaptionFunction(event);
          }
        });
        editor.on("click", function(e) {
          if($scope.$parent.parentObj.category =='bbc') {
            jQuery(tinymce.activeEditor.getBody()).addClass('bbc')  
          } else {
            jQuery(tinymce.activeEditor.getBody()).removeClass('bbc')
          }
          if($scope.$parent.photo || $scope.$parent.aiEditor) {
            var nodeImage = tinyMCE.activeEditor.dom.get('selected-image');
          }
          if($scope.$parent.gallery || $scope.$parent.aiEditor) {
            var nodeGallery = tinyMCE.activeEditor.dom.get('selected-gallery');
          }
          if($scope.$parent.embed || $scope.$parent.aiEditor) {
            var nodeEmbed = tinyMCE.activeEditor.dom.get('selected-embed');
          }
          var classes = jQuery(nodeImage).attr('class');
          if(classes) {
            var classesArray = classes.split(' ');
            if(classesArray.length>1) {
              image_id = classesArray[1].substr(9);
            } else {
              image_id = classesArray[0].substr(9);
            }
          }  
          var parents = tinyMCE.activeEditor.dom.getParents(nodeImage);
          if(jQuery(e.target).hasClass('mce-i-cut')) {
            var selectedElement = null;
            if(nodeImage) {
              selectedElement = tinyMCE.activeEditor.dom.get('selected-image');
            } else if(nodeGallery) {
              selectedElement = tinyMCE.activeEditor.dom.get('selected-gallery');
            } else if(nodeEmbed) {
              selectedElement = tinyMCE.activeEditor.dom.get('selected-embed');
            }
            
            if(selectedElement) {
              var elementToCopy;
              if(nodeImage) {
                for(var i=0; i < parents.length; i++) {
                  if(parents[i].nodeName =='CAPTIONBLOCK') {
                    elementToCopy = parents[i].outerHTML;
                  }
                }
              } else {
                elementToCopy = selectedElement.outerHTML;
              }

              // Copy to clipboard
              navigator.clipboard.writeText(elementToCopy).then(function() {
                // Remove the element after successful copy
                if(nodeImage) {
                  removeImage(parents);
                } else if(nodeGallery) {
                  jQuery(selectedElement).remove();
                  tinyMCE.activeEditor.dom.remove('edit-gallery');
                } else if(nodeEmbed) {
                  jQuery(selectedElement).remove();
                  tinyMCE.activeEditor.dom.remove('edit-embed');
                }
                editor.setDirty(true);
                editor.fire('change');
                
                // // Show success message
                // alertService('success', 'Success!', 'Element copied to clipboard', 1000);
              }).catch(function(err) {
                console.error('Failed to copy: ', err);
                alertService('danger', 'Opps! ', 'Failed to copy element');
              });
            }
          } else if(jQuery(e.target).hasClass('mce-i-remove')) {
            tinyMCE.activeEditor.dom.remove('edit-image');
            tinyMCE.activeEditor.dom.remove('selected-image')
            removeImage(parents)
            editor.setDirty(true);
            editor.fire('change')         
          } else if(jQuery(e.target).hasClass('mce-i-remove-gallery')){
            tinymce.activeEditor.selection.setCursorLocation( tinymce.activeEditor.dom.select( '#selected-gallery')[0] )
            tinyMCE.activeEditor.dom.remove('edit-gallery');
            setCursorAfterCaptionFunction();
            tinyMCE.activeEditor.dom.remove('selected-gallery')
            editor.setDirty(true);
            editor.fire('change')
          } else if(jQuery(e.target).hasClass('mce-i-editgallery')) {
            tinyMCE.activeEditor.dom.remove('edit-gallery');
            if(!nodeGallery) return
            if(jQuery(nodeGallery).attr('title')) {
              $scope.$parent.imageModalObj.gallery_title = jQuery(nodeGallery).attr('title');
            }
            if(jQuery(nodeGallery).attr('safe')) {
              $scope.$parent.imageModalObj.slideShowUnsafe = !$scope.$eval(jQuery(nodeGallery).attr('safe'))
            }
            if(jQuery(nodeGallery).attr('ids')) {
              $scope.$parent.imageModalObj.galleryUpdateIds = jQuery(nodeGallery).attr('ids'); 
              $scope.$parent.addGallerytoEditor('update');
            } else {
              alertService('danger', 'Opps! ', 'Gallery shortcode is not valid.\nRemove or correct shortcode');
            }
          }else if(jQuery(e.target).hasClass('mce-i-remove-embed')){
            tinymce.activeEditor.selection.setCursorLocation( tinymce.activeEditor.dom.select( '#selected-embed')[0] )
            tinyMCE.activeEditor.dom.remove('edit-embed');
            setCursorAfterCaptionFunction();
            tinyMCE.activeEditor.dom.remove('selected-embed')
            editor.setDirty(true);
            editor.fire('change')
          } else if(jQuery(e.target).hasClass('mce-i-editimage')) {
            if($scope.$parent.parentObj.category == 'bbc') return
            $rootScope.modalShow = true;
            tinyMCE.activeEditor.dom.remove('edit-image');
            for( var i=0; i < parents.length; i++ ) {
                if(parents[i].nodeName =='A') {
                  var parentAnchor = parents[i];
                  var image_href = jQuery(parentAnchor).attr('href');
                  var target_blank = jQuery(parentAnchor).attr('target');
                  if(target_blank) {
                    var targetblank = true;
                  } else {
                    var targetblank = false;
                  }
                  tinyMCE.activeEditor.selection.select(parents[i]);
                } else if(parents[i].nodeName == 'CAPTIONBLOCK') {
                  var parentCaptionblock = parents[i];
                  var image_signature = jQuery(parentCaptionblock).text();
                  var image_align = (!jQuery(parentCaptionblock).attr('align') || jQuery(parentCaptionblock).attr('align') === 'undefined')? 'alignnone': jQuery(parentCaptionblock).attr('align');
                  tinyMCE.activeEditor.selection.select(parents[i]);
                }

            }
            editImageArray[image_id] = {
              id : image_id,
              align : image_align,
              href : image_href,
              target_blank : targetblank,
              signature_image : image_signature
            }
            $scope.$emit('edit-image', {editImageObj:editImageArray[image_id]});
          } else {
            if(!$scope.$parent.photo && !$scope.$parent.gallery && !$scope.$parent.embed && !$scope.$parent.aiEditor) return
            var ele = e.target.nodeName;
            if(nodeImage) {
              jQuery(nodeImage).removeAttr('id');
            }
            if(nodeGallery) {
              jQuery(nodeGallery).removeAttr('id');
            }
            if(nodeEmbed) {
              jQuery(nodeEmbed).removeAttr('id');
            }
            tinyMCE.activeEditor.dom.remove('edit-image');
            tinyMCE.activeEditor.dom.remove('edit-gallery');
            tinyMCE.activeEditor.dom.remove('edit-embed');
            if(ele =="IMG") {
                jQuery(e.target).attr('id','selected-image'); 
                var edit_image_content = '<i class="mce-ico mce-i-editimage"></i><i class="mce-ico mce-i-remove"></i>';
                if($scope.$parent.aiEditor) {
                  edit_image_content = ($scope.$parent.order == '1') ? '<i class="mce-ico mce-i-cut" title="Cut image"></i><i class="mce-ico mce-i-remove"></i>' : '';
                }
                var pos = tinymce.DOM.getPos(e.target);
                var scrollTop = tinymce.activeEditor.getWin().scrollY || tinymce.activeEditor.getWin().pageYOffset;
                tinyMCE.activeEditor.dom.add(tinymce.activeEditor.getBody(),'p',{
                    id:'edit-image',
                    'style':'left:'+pos.x+'px;top:'+(pos.y + scrollTop)+'px;'
                }, edit_image_content)
            }
            if(ele=="GALLERYBLOCK") {
                jQuery(e.target).attr('id','selected-gallery');
                var galleryWidth = jQuery(e.target).innerWidth(); 
                var edit_gallery_content = '<i class="mce-ico mce-i-editgallery" title="Edit gallery"></i><i class="mce-ico mce-i-remove-gallery" title="Remove gallery"></i>';
                if($scope.$parent.aiEditor) {
                  edit_gallery_content = ($scope.$parent.order == '1') ? '<i class="mce-ico mce-i-cut" title="Cut gallery"></i><i class="mce-ico mce-i-remove-gallery" title="Remove gallery"></i>' : '';
                }
                var pos = tinymce.DOM.getPos(e.target);
                var scrollTop = tinymce.activeEditor.getWin().scrollY || tinymce.activeEditor.getWin().pageYOffset;
                tinyMCE.activeEditor.dom.add(tinymce.activeEditor.getBody(),'p',{
                    id:'edit-gallery',
                    'style':'left:'+(pos.x + galleryWidth - 45)+'px;top:'+(pos.y + scrollTop)+'px;'
                }, edit_gallery_content)
            }
            if(ele=="EMBEDBLOCK") {
                jQuery(e.target).attr('id','selected-embed');
                // var embedWidth = jQuery(e.target).innerWidth(); 
                var edit_embed_content = '<i class="mce-ico mce-i-remove-embed" title="Remove embed"></i>';
                if($scope.$parent.aiEditor) { 
                  edit_embed_content = ($scope.$parent.order == '1') ? '<i class="mce-ico mce-i-cut" title="Cut embed"></i><i class="mce-ico mce-i-remove-embed" title="Remove embed"></i>' : '';
                }
                var pos = tinymce.DOM.getPos(e.target);
                var scrollTop = tinymce.activeEditor.getWin().scrollY || tinymce.activeEditor.getWin().pageYOffset;
                // var posx =($scope.$parent.aiEditor) ? pos.x + embedWidth - 53 : pos.x + embedWidth - 24;
                tinyMCE.activeEditor.dom.add(tinymce.activeEditor.getBody(),'p',{
                    id:'edit-embed',
                    'style':'left:'+pos.x+'px;top:'+(pos.y + scrollTop)+'px;'
                }, edit_embed_content)
            }
          }
         
        });
        editor.on("change", function(e) {
          if($scope.$parent.aiEditor && e.originalEvent && e.originalEvent.type=='blur') return;
          // Only trigger on actual content changes, not selection changes
          contentSaveFunction();
          if($scope.$parent.editorCharCount) {
            updateCharacterCount();
          }
        });
        // Add a separate handler for selection changes if needed
        editor.on("SelectionChange", function(e) {
          // Handle selection changes separately if needed
          // This won't trigger the content save function
        });
        editor.addButton('formath2', {   
          icon:'h2',
          tooltip : 'Make h2', 
          onclick : function() {
            editor.execCommand('FormatBlock', false, 'h2');
          }
        });
        editor.addButton('formath3', {   
          icon:'h3',
          tooltip : 'Make h3', 
          onclick : function() {
            editor.execCommand('FormatBlock', false, 'h3');
          }
        });
        if($scope.$parent.poll) {
          editor.addButton('poll',{
            tooltip:'Insert poll',
            icon:'poll',
            onclick:function() {
              $timeout(function(){
                $scope.$parent.addPollToEditor()
              },0)
            }
          });
        }
        if($scope.$parent.rating) {
          editor.addButton('rating',{
            tooltip:'Insert rating',
            icon:'rating',
            onclick:function() {
              $timeout(function(){
                $scope.$parent.addRatingToEditor()
              },0)
            }
          });
        }
        if($scope.$parent.blog) {
          editor.addButton('blog',{
            tooltip:'Insert live blog',
            icon:'blog',
            onclick:function() {
              $timeout(function(){
                $scope.$parent.addBlogToEditor()
              },0)
            }
          });
        }
        if($scope.$parent.quote) {
          editor.addButton('quote',{
            tooltip:'Insert quote tag',
            icon:'quote',
            onclick:function() {
              $scope.requiredQuoteText = false;
              $rootScope.modalShow = true;
              $scope.videoModalShow = false;
              $scope.quoteModalShow = true;
              $scope.questionModalShow = false;
              $scope.selectedQuoteAlignAction = {value :'left'};
              $timeout(function() {
                $element.after($compile(modal)($scope));
              },10);
              $scope.insertQuote = function() {
                if($scope.quoteText) {
                  $scope.requiredQuoteText = false;
                    var insertQuoteShortcode = '[quote align="'+$scope.selectedQuoteAlignAction.value +'"]'+$scope.quoteText+'[/quote]';
                    setCursorAfterCaptionFunction();
                    tinymce.activeEditor.execCommand('mceInsertContent', false, '<p>'+insertQuoteShortcode+'</p>');
                    $element.siblings('.tinymce-modal').remove();
                    $scope.quoteText = null;
                    $scope.quoteModalShow = false;
                    $rootScope.modalShow = false;
                } else {
                  alertService('danger','Opps! ', 'Quote text is required');
                  $scope.requiredQuoteText = true;
                }
              }
            }
          });
        }
        if($scope.$parent.video) {
          editor.addButton('video',{
            tooltip:'Insert video',
            icon:'video',
            onclick:function() {
              $scope.requiredVideoId = false;
              $scope.requiredVideoType = false;
              $rootScope.modalShow = true;
              $scope.videoModalShow = true;
              $scope.quoteModalShow = false;
              $scope.questionModalShow = false;
              $scope.selectedTypeVideo = {value:'default'};
              $scope.videoType = $scope.selectedTypeVideo.value;
              $scope.videoId = null;
              $timeout(function() {
                $element.after($compile(modal)($scope));
              },10);
              $scope.switchTypeVideo = function(type) {
                $scope.videoType = type;
              }
              $scope.insertVideo = function() {
                var validation = true;
                if($scope.videoType != 'default') {
                  $scope.requiredVideoType = false;
                } else {
                  validation = false;
                  $scope.requiredVideoType = true;
                  alertService('danger','Opps! ', 'Choose video service');
                }
                if($scope.videoId) {
                  $scope.requiredVideoId = false;
                } else {
                  validation = false;
                  alertService('danger','Opps! ', 'Video ID is required');
                  $scope.requiredVideoId = true;
                }
                if(validation) {
                  $element.siblings('.tinymce-modal').remove();
                  $scope.selectedTypeVideo = {value:'default'};
                  $scope.videoModalShow = false;
                  var insertVideoShortcode = '['+ $scope.videoType +' '+ $scope.videoId +']';
                  setCursorAfterCaptionFunction();
                  tinymce.activeEditor.execCommand('mceInsertContent', false, '<p>'+insertVideoShortcode+'</p>');
                  $scope.videoId = null;
                  $rootScope.modalShow = false;
                }
              }
            }
          });
        }
        if($scope.$parent.question) {
          editor.addButton('question',{
            tooltip:'Add a Question',
            icon:'interview',
            onclick:function() {
              $scope.requiredQuestionText = false;
              $rootScope.modalShow = true;
              $scope.videoModalShow = false;
              $scope.quoteModalShow = false;
              $scope.questionModalShow = true;
              $timeout(function() {
                $element.after($compile(modal)($scope));
              },10);
              $scope.insertQuestion = function() {
                if($scope.questionText) {
                  $scope.requiredQuestionText = false;
                    setCursorAfterCaptionFunction();
                    tinyMCE.activeEditor.selection.setContent('<ul><li class="intervju">'+$scope.questionText+'</li></ul>');
                    $element.siblings('.tinymce-modal').remove();
                    $scope.questionText  = null;
                    $scope.quoteModalShow = false;
                    $rootScope.modalShow = false;
                } else {
                  $scope.requiredQuestionText = true;
                  alertService('danger','Opps! ', 'Question text is required');
                }
              }
            }
          });
        }
        if($scope.$parent.telegraftv) {
          editor.addButton('telegraftv',{
            tooltip:'Insert Telegraf TV Video',
            icon:'telegraf-tv',
            onclick:function() {
              $timeout(function(){
                $scope.$parent.insertVideotoEditor();
              },0)
            }
          });
        }
        if($scope.$parent.gallery) {
          editor.addButton('gallery',{
            tooltip:'Insert gallery',
            icon:'gallery',
            onclick:function() {
              $timeout(function(){
                $scope.$parent.addGallerytoEditor();
              },0)
            }
          });
        }
        if($scope.$parent.news) {
          editor.addButton('news',{
            tooltip:'Insert News',
            icon:'recommended-news',
            onclick:function() {
              $scope.postFromSearchObj = {}
              $timeout(function() {
                $element.after($compile(insertPost)($scope));
                document.getElementById('search-post').focus()
              },0);
              $rootScope.modalShow = true;
              $scope.postFromSearchObj.addPostFromSearch = function(obj){
                var insertPostShortcode = '[readalso id="'+obj.id +'"][/readalso]';
                setCursorAfterCaptionFunction();
                tinymce.activeEditor.execCommand('mceInsertContent', false, '<p>'+insertPostShortcode+'</p>');
                setTimeout(function(){
                  $scope.cancelInsertPostModal()
                },0)
              }
            }
          });
        }
        if($scope.$parent.embed) {
          editor.addButton('embed',{
            tooltip:'Insert embed code',
            icon:'embed',
            onclick:function() {
              $timeout(function() {
                $element.after($compile(insertEmbedCode)($scope));
                document.getElementById('insert-embedcode').focus()
              },0);
              $rootScope.modalShow = true;
              $scope.insertEmbedCode = function(){
                if($scope.embedCode) {
                  var type = 'unknown';
                  if($scope.config.embed) {
                    for (var key in $scope.config.embed) {
                      if($scope.embedCode.includes($scope.config.embed[key])) {
                        type = key
                      }
                    }
                  }
                  function replacePWithSpan(html) {
                    // Define a regular expression pattern to match <p> elements
                    var pattern = /<p(\s+[^>]*)?>([\s\S]*?)<\/p>/g;
                
                    // Replace <p> elements with <span> elements
                    var newHtml = html.replace(pattern, function(match, attrs, content) {
                        // Construct the replacement with <span> tag
                        return '<div' + (attrs || '') + '>' + content + '</div>';
                    });
                
                    return newHtml;
                }
                var embed = replacePWithSpan($scope.embedCode);
                embed = embed.replace(/<br>|<br \/>/g, "");
                // embed = embed.replace(/\[/g, '(').replace(/\]/g, ')');
                var insertEmbedShortcode = '<embedblock type="'+type+'">'+embed+'</embedblock>';
                setCursorAfterCaptionFunction();
                tinymce.activeEditor.execCommand('mceInsertContent', false, insertEmbedShortcode);
                setCursorAfterCaptionFunction();
                setTimeout(function(){
                  $scope.embedCode = '';
                  $scope.cancelInsertEmbedCodeModal()
                },0)
                } else {
                  $scope.requiredEmbedCode = true;
                  alertService('danger','Opps! ', 'Embed code is required');
                }
              }
            }
          });
        }
        if($scope.$parent.tag) {
          editor.addButton('tag',{
            tooltip:'Insert tag',
            icon:'tag',
            onclick:function() {
              var edSelection = tinymce.activeEditor.selection;
              if(!edSelection.getContent()) return;
              $scope.searchTag = edSelection.getContent({format : 'text'})
              $timeout(function() {
                $element.after($compile(insertTag)($scope));
                document.getElementById('editor-input-tag').focus()
              },0);
              $rootScope.modalShow = true;
              $scope.$on('editor-select-tag', function(event,data) {
                tinymce.activeEditor.focus();
                edSelection.setContent('<a id="selected-tag" href="'+data.selectedTagObj.tagUrl+'" target="_blank" rel="noopener">' + edSelection.getContent({format : 'text'}) + '</a>');
                tinymce.activeEditor.setContent(tinymce.activeEditor.getContent())
                var edDom = tinymce.activeEditor.dom;
                var selectedTag = edDom.select('a#selected-tag')[0]
                edSelection.select(selectedTag);
                edSelection.collapse(0)
                $timeout(function(){
                  edDom.setAttrib('selected-tag', 'id', '');
                },0)
                $timeout(function(){
                  $scope.cancelInsertTagModal()
                },0)
              });
            }
          });
        }
        if($scope.$parent.tolatin) {
          editor.addButton('tolatin',{
            tooltip:'Convert to latin',
            icon:'latin',
            onclick:function() {
              var content = tinymce.activeEditor.getContent();
              
              content = globalHelpers.specifiedShortcodePlaceholderEditorContent(content, ['embedblock','captionblock']);
              // Convert remaining content to Latin
              var latinContent = globalHelpers.cyrillicToLatin(content);
              // Restore preserved shortcodes
              latinContent = globalHelpers.specifiedShortcodeRestoreEditorContent(latinContent);
              tinymce.activeEditor.setContent(latinContent);
            } 
          });
        }
      }    
    }
    $scope.$on('$destroy', function() {
      angular.element($window).off('scroll', $scope.onScrollAction);
      angular.element($window).off('resize', $scope.onResizeAction);
    });
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/app/js/directive/tinymceBasic/tinymceBasicController.js
// module id = 452
// module chunks = 0